var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal__complete-body"},[_c('div',[_c('img',{attrs:{"src":require('@/assets/theme/icon/ok.svg'),"alt":""}})]),_c('p',{staticClass:"success__message"},[_vm._v(" "+_vm._s(_vm.message || 'Success')+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }